import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import PostAddIcon from '@material-ui/icons/PostAdd';
import CsvButton from './export/csv/CsvButton';
import PdfButton from './export/pdf/PdfButton';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
    height: 80,
  },
  addButton: {
    backgroundColor: theme.palette.primary.main,
    fill: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      filter: 'brightness(90%)',
    },
  },
  csvButton: {
    '&:hover': {
      filter: 'brightness(90%)',
    },
  },
  pdfButton: {
    '&:hover': {
      filter: 'brightness(90%)',
    },
  },
  successPdf: {
    '& * .MuiFab-root, ': {
      backgroundColor: theme.palette.alternative.main,
    },
  },
  successCsv: {
    '& * .MuiFab-root, ': {
      backgroundColor: theme.palette.alternative.main,
    },
  },
}));

const AdminPanel = ({ onOpen, refs }) => {
  const classes = useStyles();
  const { metricsRef, tableDataRef, allDataRef } = refs;

  const handleOpen = () => {
    onOpen?.();
  };

  return (
    <Box className={classes.root}>
      <Box m={1} style={{ position: 'relative' }}>
        <Button
          className={classes.addButton}
          variant="contained"
          color="primary"
          startIcon={<PostAddIcon />}
          onClick={handleOpen}
          size="large"
        >
          Add
        </Button>
      </Box>
      <PdfButton classes={classes} refs={{ metricsRef, tableDataRef }} />
      <CsvButton classes={classes} allDataRef={allDataRef} />
    </Box>
  );
};

AdminPanel.defaultProps = {
  refs: {},
  onOpen: {},
};

AdminPanel.propTypes = {
  refs: PropTypes.object,
  onOpen: PropTypes.func,
};

export default AdminPanel;
